let elements = {
  //pick: 3,
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page053_game0/img/bcg1.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page053_game0/audio/false.mp3',
    // positive: 'games/page053_game0/audio/7_mole.mp3',
    click: 'games/page053_game0/audio/click.mp3',
    icon: {
      on: 'games/page053_game0/img/audioOn.png',
      off: 'games/page053_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 60,
    height: 60,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 566,
    height: 873,
  },
  layoutItems: [
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 58,
        y: -37,
      },
    },
    {
      pos: {
        x: 1240,
        y: -37,
      },
    },
  ],
  shuffle: true,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page053_game0/audio/77_clown.mp3',
          correct: {
            image: {
              src: 'games/page053_game0/img/3b.webp',
            },
            width: 566,
            height: 873,
            correctItems: {
              images: [
                {
                  src: 'games/page053_game0/img/3bo.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 566,
                  height: 873,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page053_game0/img/3a.webp',
            },
            width: 579,
            height: 918,
            incorrectItems: {
              images: [
                {
                  src: 'games/page053_game0/img/3aw.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 579,
                  height: 918,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  staticMaskConfig: [
    {
      id: 'm1',
      pos: {
        x: 784,
        y: 41,
      },
      unit: 'px',
      click: { src: 'games/page053_game0/audio/click.mp3' },
      src: 'games/page053_game0/img/folia.webp',
    },
  ],
  mbStaticAudioItemData: [
    {
      src: 'games/page053_game0/audio/77_clown.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page053_game0/img/audioOn.png', iconOff: 'games/page053_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 917,
        y: 542,
      },
      unit: 'px',
    },
  ],
};

export default elements;
